var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchFullLtr = function SvgSearchFullLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 40.62C9 23.155 23.327 9 41 9s32 14.156 32 31.62c0 17.462-14.327 31.618-32 31.618S9 58.082 9 40.62m61.064 25.511a3.03 3.03 0 0 0-4.184.059 2.94 2.94 0 0 0 0 4.195l20.995 20.746.061.059a3.03 3.03 0 0 0 4.185-.06 2.94 2.94 0 0 0 0-4.194L70.126 66.19z"
  })));
};
export default SvgSearchFullLtr;